import ShuffleFirst from './assets/images/jpg-images/shuffle1.jpg'
import ShuffleSecond from './assets/images/jpg-images/shuffle2.jpg'
import ShuffleThird from './assets/images/jpg-images/shuffle3.jpg'
import ShuffleFourth from './assets/images/jpg-images/shuffle4.jpg'


const shuffleData = [
    {img: ShuffleFirst},
    {img: ShuffleSecond},
    {img: ShuffleThird},
    {img: ShuffleFourth}
]

export default shuffleData